import { createBrowserRouter, Navigate } from "react-router-dom";
import Root from "../components/Root";
import AuthLayout from "../components/AuthLayout";
import AuthGuard from "../layouts/AuthGuard";

// Pages
import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
import VerifySignupOTPPage from "../pages/auth/VerifySignupOTPPage";
import GuestDashboard from "../pages/GuestDashboard";
import GuestProjectsPage from "../pages/GuestProjectsPage";
import GuestProjectTasksPage from "../pages/GuestProjectTasksPage";
import GuestSettingsPage from "../pages/GuestSettingsPage";
import TasksPage from "../pages/TasksPage";

export const router = createBrowserRouter([
  // Auth routes (public)
  {
    path: "/login",
    element: <AuthLayout />,
    children: [
      { index: true, Component: LoginPage },
    ],
  },
  {
    path: "/signup",
    element: <AuthLayout />,
    children: [
      { index: true, Component: SignupPage },
    ],
  },
  {
    path: "/verify-signup-otp",
    element: <AuthLayout />,
    children: [
      { index: true, Component: VerifySignupOTPPage },
    ],
  },
  // Protected routes (require authentication)
  {
    element: <AuthGuard />,
    children: [
      {
        path: "/",
        element: <Root />,
        children: [
          { index: true, element: <GuestDashboard /> },
          { path: "dashboard", element: <GuestDashboard /> },
          { path: "tasks", Component: TasksPage },
          { path: "projects", element: <GuestProjectsPage /> },
          { path: "projects/:projectId", element: <GuestProjectTasksPage /> },
          { path: "templates", element: <Navigate to="/settings" replace /> },
          { path: "settings", element: <GuestSettingsPage /> },
        ],
      },
    ],
  },
]);
